// Capture third-party OAuth callback params before Keycloak runs
import './utils/capture-oauth-params';
import './index.css';

import { createRoot } from 'react-dom/client';

import App from './app.tsx';

createRoot(document.getElementById('root')!).render(<App />);
